import type { ReactNode } from 'react'

import { EmptyState, Panel } from '../../ui/primitives'

/**
 * Список предложений обмена по статусам: входящие, исходящие, завершённые.
 *
 * Экран-заготовка: разметка и место под данные есть, загрузка из API
 * появится вместе с наполнением каталога.
 */
export function TradesScreen(): ReactNode {
  return (
    <section>
      <h1>Сделки</h1>
      <Panel>
        <EmptyState text="Пока пусто" />
      </Panel>
    </section>
  )
}
